/** Drop the supplier brand from any string shown to agents or guests. */
export function hideSupplierBrandFromUserText(text, fallback = "") {
  const cleaned = String(text ?? "")
    .replace(/hubwayz/gi, "")
    .replace(/[ \t]{2,}/g, " ")
    .replace(/\s+([,.;:)])/g, "$1")
    .replace(/\(\s*\)/g, "")
    .trim();
  return cleaned || fallback;
}
